
import request from '@/utils/request'

const http = request()

export const viewPrj = (projectId, isDetail = false) => (isDetail ? http.post('/project/school/detail', { projectId }) : http.post('/project/school/view', { projectId }))
